import {
    USER_CAN_ACCESS,
} from  "../actions/types";

export const userAccessReducer = (state = false, action) => {
    switch (action.type) {
        case USER_CAN_ACCESS:
            return action.payload;
        default:
            return state;
    }
};